module.exports = __webpack_public_path__ + "static/media/400110_01.d5654388.png";